// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  Box,
  Flex,
  ShimmerTitle,
  Typography,
  UniconWrapper,
} from '@teamnine/pcj-ui-v2'
import { useTheme } from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { KeyboardArrowRight } from '@/utils/material-icons'
import LinkButton from '@/app/shared/components/LinkButton'
import * as Styled from './Styles'

export type BreadcrumbItem = {
  label: string
  to?: string
  onClick?: () => void
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
  isLoading?: boolean
}

export default function Breadcrumbs({ items, isLoading }: BreadcrumbsProps) {
  const navigate = useNavigate()
  const { colors } = useTheme()

  return (
    <Styled.Wrapper align="center">
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        const handleClick = () => {
          if (item.onClick) return item.onClick()
          if (item.to) navigate(item.to)
        }
        return (
          <Flex key={index} gap={8}>
            {!isLast ? (
              <Flex align="center">
                {isLoading ? (
                  <Box w="100px">
                    <ShimmerTitle line={1} variant="primary" />
                  </Box>
                ) : (
                  <Box ml={index === 1 ? 8 : undefined}>
                    <LinkButton label={item.label} onClick={handleClick} />
                  </Box>
                )}
                <UniconWrapper
                  Icon={KeyboardArrowRight}
                  color={colors.nggray600}
                />
              </Flex>
            ) : (
              <>
                {isLoading ? (
                  <Box w="100px">
                    <ShimmerTitle line={1} variant="primary" />
                  </Box>
                ) : (
                  <Typography color={colors.nggray700} ml={8}>
                    {item.label}
                  </Typography>
                )}
              </>
            )}
          </Flex>
        )
      })}
    </Styled.Wrapper>
  )
}
